<div class="group relative w-full">
  <label
    for="creator-search-input"
    class="pointer-events-none absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
    {{ label() }}
  </label>

  <div class="relative">
    <input
      id="creator-search-input"
      type="text"
      [value]="searchTerm()"
      (input)="onInput($any($event.target).value)"
      (focus)="onFocus()"
      [placeholder]="placeholder()"
      class="w-full rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] font-medium text-gray-800 transition-all outline-none placeholder:text-gray-300 hover:border-gray-600 focus:border-black ltr:pl-10 rtl:pr-10" />

    <span class="pointer-events-none absolute top-1/2 -translate-y-1/2 text-gray-400 ltr:left-3 rtl:right-3">
      <app-search-icon />
    </span>
  </div>

  @if (isOpen()) {
    <div
      class="absolute top-full z-50 mt-2 max-h-60 w-full overflow-y-auto rounded-[10px] border border-gray-400 bg-white p-2 shadow-lg">
      @if (isLoading()) {
        <div class="flex items-center justify-center p-4">
          <app-loading />
        </div>
      } @else if (errorMessage()) {
        <app-error-data [title]="errorMessage()!" />
      } @else if (filteredItems.length === 0) {
        <div class="p-4 text-center text-sm font-medium text-gray-500">
          {{ noResultsText() }}
        </div>
      } @else {
        @for (item of filteredItems; track item.id) {
          <div
            (click)="selectItem(item)"
            class="flex cursor-pointer items-center gap-3 rounded-[8px] border-b border-gray-100 p-3 transition-all last:border-none hover:bg-gray-100">
            <div class="flex flex-row-reverse items-center gap-2 text-[14px] font-semibold text-gray-800">
              <span>{{ item.fullName }}</span>
            </div>
          </div>
        }
      }
    </div>
  }
</div>